import Vue from 'vue';

new Vue({
    data() {
        return {
            expanded: false,
        };
    },

    methods: {
        collapse() {
            this.expanded = false;
        },

        expand() {
            this.expanded = true;
        }
    },

    watch: {
        expanded() {
            const classes = document.body.classList;
            const method = this.expanded ? 'add' : 'remove';

            classes[method]('overflow-hidden');
        }
    }
}).$mount('#header');
